<template>
  <div class="tss-menu">
    <div class="tss-content">
      <div class="left">
        <img src="../assets/logo.png" alt="">
        <p>TSS RENOVATION</p>
      </div>
      <div class="tss-menubox">
        <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">หน้าแรก</div>
        <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
          สินค้าและบริการ
        </div>
        <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
          เกี่ยวกับเรา
        </div>
        <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
          ความแข็งแกร่งของทีม
        </div>
        <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
          ติดต่อเรา
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tss-menu {
  position: absolute;
  top: 0px;
  left: 360px;
  z-index: 99;
  width: 1200px;

  .tss-content {
    display: flex;
    justify-content: space-between;
    background-size: 100% 100%;

    .left {
      width: 180px;
      height: 180px;
      padding: 16px 10px;
      background: #F65331;
      box-sizing: border-box;
      text-align: center;

      img {
        margin-bottom: 10px;
        width: 100px;
        height: 100px;
      }

      p {
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

  .tss-menubox {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 18px;
    color: #FFFFFF;
    height: 72px;
    cursor: pointer;
    background: #303937;

    div {
      height: 72px;
      line-height: 72px;
      padding: 0 30px;
      box-sizing: border-box;
      background: #303937;
    }
  }

  .select {
    font-weight: 600;
    background: #F65331 !important;
  }
}
</style>
